/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountingFormulaRepresentation } from './AccountingFormulaRepresentation';
import {
    AccountingFormulaRepresentationFromJSON,
    AccountingFormulaRepresentationFromJSONTyped,
    AccountingFormulaRepresentationToJSON,
    AccountingFormulaRepresentationToJSONTyped,
} from './AccountingFormulaRepresentation';
import type { ResultType } from './ResultType';
import {
    ResultTypeFromJSON,
    ResultTypeFromJSONTyped,
    ResultTypeToJSON,
    ResultTypeToJSONTyped,
} from './ResultType';

/**
 * 
 * @export
 * @interface AccountingMetricCreateRequest
 */
export interface AccountingMetricCreateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountingMetricCreateRequest
     */
    name: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountingMetricCreateRequest
     */
    lc: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccountingMetricCreateRequest
     */
    unit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountingMetricCreateRequest
     */
    visible: boolean;
    /**
     * all features that are assigned to the metric
     * @type {Array<string>}
     * @memberof AccountingMetricCreateRequest
     */
    licenseFeatures: Array<string>;
    /**
     * 
     * @type {ResultType}
     * @memberof AccountingMetricCreateRequest
     */
    resultType: ResultType;
    /**
     * 
     * @type {Array<AccountingFormulaRepresentation>}
     * @memberof AccountingMetricCreateRequest
     */
    formulas?: Array<AccountingFormulaRepresentation>;
}



/**
 * Check if a given object implements the AccountingMetricCreateRequest interface.
 */
export function instanceOfAccountingMetricCreateRequest(value: object): value is AccountingMetricCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('lc' in value) || value['lc'] === undefined) return false;
    if (!('visible' in value) || value['visible'] === undefined) return false;
    if (!('licenseFeatures' in value) || value['licenseFeatures'] === undefined) return false;
    if (!('resultType' in value) || value['resultType'] === undefined) return false;
    return true;
}

export function AccountingMetricCreateRequestFromJSON(json: any): AccountingMetricCreateRequest {
    return AccountingMetricCreateRequestFromJSONTyped(json, false);
}

export function AccountingMetricCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountingMetricCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'lc': json['lc'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'visible': json['visible'],
        'licenseFeatures': json['licenseFeatures'],
        'resultType': ResultTypeFromJSON(json['resultType']),
        'formulas': json['formulas'] == null ? undefined : ((json['formulas'] as Array<any>).map(AccountingFormulaRepresentationFromJSON)),
    };
}

export function AccountingMetricCreateRequestToJSON(json: any): AccountingMetricCreateRequest {
    return AccountingMetricCreateRequestToJSONTyped(json, false);
}

export function AccountingMetricCreateRequestToJSONTyped(value?: AccountingMetricCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'lc': value['lc'],
        'unit': value['unit'],
        'visible': value['visible'],
        'licenseFeatures': value['licenseFeatures'],
        'resultType': ResultTypeToJSON(value['resultType']),
        'formulas': value['formulas'] == null ? undefined : ((value['formulas'] as Array<any>).map(AccountingFormulaRepresentationToJSON)),
    };
}

